var _a;
import { ENDPOINTS } from '../../../types/endpoints';
import { urlUtils } from '../../utils/url.utils';
import { Logger } from '../../utils/Logger';
var SHORT_ROUTES_NAMES = (_a = {
        '/': 'MR1'
    },
    _a[ENDPOINTS.MORTGAGE_ROUTE_1] = 'MR1',
    _a[ENDPOINTS.REFERRAL_SCOPE] = 'MR1',
    _a[ENDPOINTS.MORTGAGE_ROUTE_2] = 'MR2',
    _a[ENDPOINTS.MORTGAGE_ROUTE_3] = 'MR3',
    _a[ENDPOINTS.MORTGAGE_ROUTE_4] = 'MR4',
    _a[ENDPOINTS.MORTGAGE_ROUTE_5] = 'MR5',
    _a[ENDPOINTS.MORTGAGE_ROUTE_6] = 'MR6',
    _a[ENDPOINTS.MORTGAGE_ROUTE_7] = 'MR7',
    _a[ENDPOINTS.MORTGAGE_ROUTE_8] = 'MR8',
    _a[ENDPOINTS.MORTGAGE_ROUTE_9] = 'MR9',
    _a[ENDPOINTS.FESTGELD] = 'FESTGELD',
    _a[ENDPOINTS.TAGESGELD] = 'TAGESGELD',
    _a[ENDPOINTS.KREDITKARTE] = 'KREDITKARTE',
    _a);
var AmplitudeService = /** @class */ (function () {
    function AmplitudeService() {
    }
    // @note: dirty function, based on location for quick solution
    // need refactoring
    AmplitudeService.getShortRouteName = function () {
        var pathname = window.location.pathname;
        var pathnameScope = urlUtils.getPathnameScope(pathname);
        return SHORT_ROUTES_NAMES.hasOwnProperty(pathnameScope)
            ? SHORT_ROUTES_NAMES[pathnameScope]
            : null;
    };
    AmplitudeService.isMethodReady = function (methodName) {
        return (!!window &&
            !!window.analytics &&
            typeof window.analytics[methodName] === 'function');
    };
    AmplitudeService.trackPage = function (step) {
        var _a;
        step = step || '';
        var shortRouteName = this.getShortRouteName();
        if (shortRouteName !== null && this.isMethodReady('page')) {
            Logger.debug('Amplitude: track route', shortRouteName, step);
            (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.page("".concat(shortRouteName).concat(step));
        }
    };
    AmplitudeService.trackEvent = function (eventName) {
        var _a;
        var shortRouteName = this.getShortRouteName();
        if (shortRouteName !== null && this.isMethodReady('track')) {
            (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.track("".concat(shortRouteName, "__").concat(eventName));
        }
    };
    return AmplitudeService;
}());
export { AmplitudeService };
